import { css } from "@emotion/react";
import Link from "next/link";
import { H8_16 } from "../../Typography";
import { blueColor, darkColor, lightBlueColor } from "@/constants/colors";

interface SportLinkProps {
  title: string;
  href: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const SportLink = ({ title, href, Icon }: SportLinkProps) => {
  return (
    <Link href={href}>
      <div
        css={css`
          display: flex;
          gap: 14px;
          align-items: center;
          padding: 6px 16px;
          border: 2px solid transparent;
          transition: border-color 0.2s ease-in-out;
          border-radius: 10px;
          &:hover {
            border-color: ${blueColor};
          }
        `}
      >
        <div
          css={css`
            display: flex;
            width: 50px;
            height: 50px;
            flex-shrink: 0;
            background-color: ${blueColor};
            align-items: center;
            justify-content: center;
            border-radius: 100%;
          `}
        >
          <Icon
            css={css`
              width: 24px;
              height: 24px;
              color: ${lightBlueColor};
            `}
          />
        </div>
        <div
          css={css`
            flex: 1;
            min-width: 0;
          `}
        >
          <H8_16
            css={css`
              color: ${darkColor};
              font-size: 14px;
              font-style: normal;
              font-weight: medium;
              line-height: normal;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            `}
          >
            {title}
          </H8_16>
        </div>
      </div>
    </Link>
  );
};

export default SportLink;
